import { createStore, compose, applyMiddleware } from 'redux';
import { syncHistoryWithStore } from 'react-router-redux';
import { browserHistory } from 'react-router';
import thunk from 'redux-thunk';
import rootReducer from './reducers/root-reducers';

const store = createStore(rootReducer);

export const history = syncHistoryWithStore(browserHistory, store);

export default store;



/** WEBPACK FOOTER **
 ** ./app/store.js
 **/